import { routes } from '~/config/routes'
import { CurrentUser } from '~/types'
import { Role } from '~/types/graphql'
import Router from 'next/router'

export const redirectUser = (user: CurrentUser, workspaceId?: string) => {
  const role = user.isMasterAdmin ? Role.Admin : user.roles[0].role
  const id = workspaceId ?? user.roles[0].workspace.id

  switch (role) {
    case Role.Admin: {
      const href = routes.dashboard.pages
      const as = href.replace('[workspace]', id)
      Router.replace(href, as)
      return
    }
    case Role.Creator: {
      const href = routes.dashboard.pages
      const as = href.replace('[workspace]', id)
      Router.replace(href, as)
      return
    }
    case Role.Finance: {
      const href = routes.dashboard.transactions
      const as = href.replace('[workspace]', id)
      Router.replace(href, as)
      return
    }
  }
}
